// ─────────────────────────────────────────────────────────────
// CRÉATIONS DE L'ADMIN — objets, sols, catégories, confréries
//
// Tout ce que l'admin ajoute depuis l'interface est stocké côté
// serveur et rechargé au démarrage. Ici on se contente de l'injecter
// dans les structures existantes :
//
//   catalog.js   → CATALOG / BY_ID / CATEGORIES (mutés en place)
//   sets.js      → SETS (muté en place)
//   overrides.js → l'image de chaque objet perso, enregistrée comme
//                  un override normal. Conséquence : le moteur de
//                  rendu, les vignettes de la boutique, du sac et de
//                  l'éditeur traitent un objet créé par l'admin
//                  exactement comme une tuile Kenney. Aucun cas
//                  particulier à maintenir nulle part.
// ─────────────────────────────────────────────────────────────
import api from "@/lib/api";
import { setCustomItems, setCustomCategories } from "./catalog.js";
import { setCustomSets } from "./sets.js";
import { registerOverride } from "./overrides.js";

let DATA = { items: [], categories: [], confreries: [] };
let loaded = false;

export function customData() {
  return DATA;
}
export function customReady() {
  return loaded;
}

export function applyCustom(data) {
  DATA = {
    items: data?.items || [],
    categories: data?.categories || [],
    confreries: data?.confreries || [],
  };
  setCustomCategories(DATA.categories);
  setCustomItems(DATA.items, DATA.confreries);
  setCustomSets(DATA.confreries, DATA.items);
  for (const it of DATA.items) {
    if (!it?.id || !it.imageDataUrl) continue;
    registerOverride(it.id, {
      url: it.imageDataUrl,
      anchorY: it.anchorY ?? 291,
      isCube: !!it.isCube,
      scale: it.scale || Math.max(1, it.size?.[0] || 1),
      bbox: it.bbox || null,
    });
  }
  loaded = true;
  return DATA;
}

export async function loadCustomItems() {
  try {
    const r = await api.get(`/oasis/custom-items?t=${Date.now()}`);
    return applyCustom(r.data);
  } catch {
    loaded = true;
    return DATA;
  }
}

export async function saveCustomItem(item) {
  const r = await api.post("/oasis/admin/custom-item", item);
  await loadCustomItems();
  return r.data;
}

export async function deleteCustomItem(id) {
  await api.delete(`/oasis/admin/custom-item/${id}`);
  await loadCustomItems();
}

export async function saveCategory(cat) {
  await api.post("/oasis/admin/category", cat);
  await loadCustomItems();
}

export async function deleteCategory(id) {
  await api.delete(`/oasis/admin/category/${id}`);
  await loadCustomItems();
}

export async function saveConfrerie(def) {
  await api.post("/oasis/admin/confrerie-def", def);
  await loadCustomItems();
}

export async function deleteConfrerie(id) {
  await api.delete(`/oasis/admin/confrerie-def/${id}`);
  await loadCustomItems();
}
